'use client';

import { useState } from 'react';
import useWishlistState, { type WishlistItem } from './useWishlistState';
import useCartState from '~/features/cart/useCartState';

/**
 * Reusable wishlist actions: share & move-to-cart.
 * Used by both the hover card and the full wishlist page.
 */
export default function useWishlistActions() {
  const wishlist = useWishlistState();
  const cart = useCartState();
  const addToCart = cart.useUpsertCartItemMutation();
  const [isMoving, setIsMoving] = useState(false);
  const allReady = wishlist.items.every(item => item.variantId !== null && item.languageId !== null);
  async function moveItemsToCart(items: WishlistItem[]) {
    if (!items.length || isMoving) return;
    setIsMoving(true);
    try {
      for (const item of items) {
        if (!item.variantId || !item.languageId) continue;
        await addToCart.mutateAsync({
          cartItemID: null,
          variantId: Number(item.variantId),
          languageId: Number(item.languageId),
          boostAdId: null
        });
        wishlist.remove(item.activityId);
      }
    } finally {
      setIsMoving(false);
    }
  }
  return {
    moveItemsToCart,
    moveAllReadyToCart() {
      const readyItems = wishlist.items.filter(item_0 => item_0.variantId !== null && item_0.languageId !== null);
      return moveItemsToCart(readyItems);
    },
    isMoving,
    allReady
  };
}